/* eslint-disable prettier/prettier */
import { Placeholder } from 'assets/images'
import { DeleteIcon } from 'assets/svg'
import { useFormik } from 'formik'
import { useEffect, useState } from 'react'
import AsyncSelect from 'react-select/async'
import { dealsService, productService } from 'services'
import { _object } from 'utils/interfaces'

const DealOfTheWeek = () => {
  const [selectedProducts, setSelectedProducts] = useState<_object[]>([])
  const [displayProducts, setDisplayProducts] = useState<_object[]>([])
  const [open, setOpen] = useState(false)
  const [dealId, setDealId] = useState('')
  const [dealOfTheWeek, setDealOfTheWeek] = useState<_object>([])
  const [dealOfTheWeekData, setDealOfTheWeekData] = useState<_object[]>([])

  useEffect(() => {
    dealsService.getDeals({ per_page: 90 }).then((results: _object) => {
      setDealOfTheWeekData(results.items)

      const firstItem = results.items[0]
      if (firstItem) {
        setDealOfTheWeek({
          label: firstItem.name,
          value: firstItem.id
        })

        setDealId(firstItem.id)
        setSelectedProducts(firstItem.products || [])
      }
    })

    // dealsService.getDealOfTheWeek().then((results: _object) => {

    // setDealOfTheWeekData(results.items)

    // const firstItem = results.items[0]
    // if (firstItem) {
    //   setDealOfTheWeek({
    //     label: firstItem.deal.name,
    //     value: firstItem.deal.id
    //   })

    //   setDealId(firstItem.deal.id)
    //   setSelectedProducts(firstItem.products || [])
    // }
    // })
  }, [])

  const loadProductOptions = async () => {
    try {
      const response = await dealsService.getDeals({ per_page: 90 })

      // setDeal(response)

      return response.items.map((item: _object) => ({
        value: item.id,
        label: item.name
      }))
    } catch (error) {
      console.error('Failed to load deals', error)
      return []
    }
  }

  useEffect(() => {
    const selectedItems = selectedProducts.map((item: _object) => ({
      ...item,
      source: 'selected'
    }))
    setDisplayProducts(selectedItems)
  }, [selectedProducts])

  const handleDeleteProduct = (id: string) => {
    setSelectedProducts((prev) => prev.filter((item: _object) => item.id !== id))
  }

  const loadProducts = async (inputValue: string) => {
    try {
      const response = await productService.getProducts({
        q: inputValue,
        page: 1,
        per_page: 20,
        sort: 'created_at'
      })

      return response.items.map((item: _object) => ({
        value: item,
        label: item.title
      }))
    } catch (error) {
      console.error('Failed to load products', error)
      return []
    }
  }

  const formik: any = useFormik({
    initialValues: {
      deal_id: dealId,
      product_ids: selectedProducts.length > 0 && selectedProducts.map((item: _object) => item.id),
      // : dealOfTheWeekProducts?.product_ids,

      is_active: true
    },
    enableReinitialize: true,

    onSubmit: async (values) => {
      dealsService.dealOfTheWeek(values)
      dealsService.updateDeal(values?.deal_id, {
        product_ids: values?.product_ids,
        status: 'active'
      })
    }
  })
  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <div className="grid grid-cols-2 gap-5">
          <div>
            <div className="mb-4">
              <label className="mb-2 flex text-sm leading-none font-medium text-gray-700">
                Deal of the week
              </label>
              <AsyncSelect
                cacheOptions
                defaultOptions
                value={dealOfTheWeek}
                loadOptions={loadProductOptions}
                onChange={(selectedOption) => {
                  if (selectedOption) {
                    setDealOfTheWeek(selectedOption)

                    const selected = dealOfTheWeekData.find(
                      (item: _object) => item.id === selectedOption.value
                    )

                    if (selected) {
                      setDealId(selected.id)
                      setSelectedProducts(selected.products || [])

                      formik.setFieldValue('deal_id', selected.id)
                      formik.setFieldValue(
                        'product_ids',
                        (selected.products || []).map((p: _object) => p.id)
                      )
                    }
                  } else {
                    setDealOfTheWeek({})
                    setDealId('')
                    setSelectedProducts([])

                    formik.setFieldValue('deal_id', '')
                    formik.setFieldValue('product_ids', [])
                  }
                }}
                placeholder="Search and select deal"
                isSearchable
                isClearable
              />
            </div>

            <div>
              <label className="mb-2 flex text-sm leading-none font-medium text-gray-700">
                Add Products
              </label>
              <div className="flex flex-col gap-4">
                {displayProducts.map((item: _object, i: number) => {
                  return (
                    <div className="flex items-start gap-3" key={i}>
                      <div className="flex-1 space-y-4">
                        <div className="flex items-center justify-between rounded-md border border-gray-200 bg-gray-50 p-3 px-4">
                          <div className="flex items-center gap-4">
                            <img
                              src={item.image || Placeholder}
                              className="h-8 w-8 rounded-md object-cover"
                              alt={item.title}
                            />
                            <div>
                              <h6 className="font-medium text-purple-900">
                                {item?.new_title ? item?.new_title : item?.title}
                              </h6>
                            </div>
                          </div>
                          <button type="button" onClick={() => handleDeleteProduct(item.id)}>
                            <DeleteIcon />
                          </button>
                        </div>
                      </div>
                    </div>
                  )
                })}
                <div className="flex items-start justify-between gap-3">
                  {!open && (
                    <div
                      className="relative flex h-32 w-32 cursor-pointer items-center justify-center rounded-md border-2 border-dashed border-purple-900"
                      title="Add Product"
                      onClick={() => {
                        setOpen(true)
                      }}
                    >
                      <span className="text-2xl font-bold text-purple-900">+</span>
                    </div>
                  )}
                  {open && (
                    <div className="mt-4">
                      <AsyncSelect
                        cacheOptions
                        defaultOptions
                        loadOptions={loadProducts}
                        onChange={(e: any) => {
                          if (e?.value) {
                            const product = e.value
                            const alreadyExists = selectedProducts.some((p) => p.id === product.id)
                            if (!alreadyExists) {
                              setSelectedProducts((prev) => [...prev, product])
                            }
                            setOpen(false)
                          }
                        }}
                        placeholder="Search and select product"
                        isSearchable
                        isClearable
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>

            <button type="submit"
              className="mt-4 rounded bg-purple-900 hover:bg-purple-950 font-medium px-4 py-2 text-white text-sm disabled:opacity-50"
              disabled={dealOfTheWeekData?.length === 0}>
              {location.pathname.endsWith('/add') ? 'Add Deal' : 'Save Changes'}
            </button>
          </div>
        </div>
      </form>
    </>
  )
}
export default DealOfTheWeek
